var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-list',{attrs:{"title":_vm.$t('pages.partners.title'),"path":"partner","alias":"partners","as-groups":"","fetch":_vm.$api.partner.getPartners,"params":_vm.params}})
}
var staticRenderFns = []

export { render, staticRenderFns }